import { StringUtil } from "@mcleod/core";
import { AutogenLayoutRatewareCalcUomCode } from "./autogen/AutogenLayoutRatewareCalcUomCode";

export class RatewareCalcUomCode extends AutogenLayoutRatewareCalcUomCode {

    public fieldCodeStartsWithRW(): boolean {
        if (!StringUtil.isEmptyString(this.textboxFieldCode.text) && (!this.textboxFieldCode.text.startsWith("RW_") ||
            this.textboxFieldCode.text.length < 4)) {
            return false;
        }
    }
}
